import { useState } from "react";

import { IAlphaMiniCartModel, IOrderItem } from 'Types/Litium';
import {type RowSpecificVariantSelect} from 'Components/CustomerServiceCart';

const CartItemStock = ({
    orderItem,
    variantSelectData,
    translations,
}: {
    orderItem: IOrderItem;
    variantSelectData: RowSpecificVariantSelect;
    translations: IAlphaMiniCartModel['translations'];
}) => {
    const [isStockListOpen, setIsStockListOpen] = useState(false);

    const stockDeliveryDateOnly = (dateTime: string) => {
        return dateTime.split('T')[0];
    }

    return (
        <div className="mt-3.5 text-xs">
            <div className='flex justify-between'>
                <div>                                   
                    <div
                        className={`${orderItem.itemQuantity
                            .showNoMoreInStockMessage
                            ? 'text-errorRed'
                            : 'text-black'
                            }`}
                        dangerouslySetInnerHTML={{ __html: orderItem.stockStateDescription }}>
                    </div>                                 
                    {isStockListOpen &&
                        <div className="flex mt-1">
                            {`${translations.customerServiceCartInStock}: ${variantSelectData.quantity} ${translations.customerServiceCartUnit}`}
                        </div>
                    }
                    {isStockListOpen && variantSelectData.purchaseOrders.map((o) => (
                        <div key={o.deliveryDate} className="flex mt-1">
                            {`${stockDeliveryDateOnly(o.deliveryDate)}: ${o.quantityInPurchaseOrder} ${translations.customerServiceCartUnit}`}
                        </div>
                    ))}
                    {isStockListOpen && variantSelectData.overbooked &&
                        <div className="flex mt-1">
                            {translations.customerServiceCartOverbooking}
                        </div>
                    }
                </div>
                <div className="flex items-start">
                    <button
                        className="underline cursor-pointer select-none"
                        onClick={() => setIsStockListOpen(!isStockListOpen)}
                    >
                        {isStockListOpen
                        ? translations.customerServiceCartCloseStock
                        : translations.customerServiceCartShowStock}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CartItemStock;
